export function initLocationMap() {
    const wrapper = document.querySelector('.location-map');
    const canvas = wrapper?.querySelector('[data-location-map]');
    const data = document.querySelector('#location-map-data');
    const key = wrapper?.dataset.mapsKey?.trim();
    const markerUrl = wrapper?.dataset.markerUrl;

    if (!wrapper || !canvas || !data || !key) return;

    let markers;
    try {
        markers = JSON.parse(data.textContent || '[]');
    } catch {
        return;
    }
    if (!markers.length) return;

    const callbackName = 'tncfsInitLocationMap';
    let mapHost;
    const restoreStaticMap = () => mapHost?.remove();
    window.gm_authFailure = restoreStaticMap;
    window[callbackName] = () => {
        if (!window.google?.maps) return;

        mapHost = document.createElement('div');
        mapHost.className = 'location-map__interactive';
        canvas.append(mapHost);
        const map = new window.google.maps.Map(mapHost, {
            center: { lat: 36.13, lng: -86.8 },
            zoom: 9,
            minZoom: 6,
            maxZoom: 13,
            scrollwheel: false,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
            styles: [
                { elementType: 'geometry', stylers: [{ color: '#F3F1EC' }] },
                { elementType: 'labels.text.fill', stylers: [{ color: '#AFAC97' }] },
                { elementType: 'labels.text.stroke', stylers: [{ color: '#EDEDE7' }] },
                { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c9b2a6' }] },
                { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#dcd2be' }] },
                { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#ae9e90' }] },
                { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#F7F6F2' }] },
                { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
                { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#93817c' }] },
                { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#E6F1DF' }] },
                { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ visibility: 'off' }] },
                { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#f5f1e6' }] },
                { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#fdfcf8' }] },
                { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#F0F0F1' }] },
                { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#EAEAEA' }] },
                { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#EFEFEE' }] },
                { featureType: 'road.highway.controlled_access', elementType: 'geometry.stroke', stylers: [{ color: '#DFE0E1' }] },
                { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#806b63' }] },
                { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
                { featureType: 'transit.line', elementType: 'labels.text.fill', stylers: [{ color: '#8f7d77' }] },
                { featureType: 'transit.line', elementType: 'labels.text.stroke', stylers: [{ color: '#ebe3cd' }] },
                { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
                { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#C7D7FF' }] },
                { featureType: 'transit.station.airport', stylers: [{ visibility: 'off' }] },
                { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
                { featureType: 'poi.school', stylers: [{ visibility: 'off' }] },
                { featureType: 'poi.attraction', stylers: [{ visibility: 'off' }] },
                { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#92998d' }] },
            ],
        });
        const infoWindow = new window.google.maps.InfoWindow();

        for (const location of markers) {
            const position = { lat: Number(location.lat), lng: Number(location.lng) };
            if (!Number.isFinite(position.lat) || !Number.isFinite(position.lng)) continue;

            const marker = new window.google.maps.Marker({
                map,
                position,
                title: location.name,
                icon: markerUrl ? {
                    url: markerUrl,
                    scaledSize: new window.google.maps.Size(26, 38),
                } : undefined,
                animation: window.google.maps.Animation.DROP,
            });
            marker.addListener('click', () => {
                const content = document.createElement('div');
                const name = document.createElement('strong');
                const address = document.createElement('p');
                const directions = document.createElement('a');
                name.textContent = location.name;
                address.textContent = location.address;
                directions.textContent = 'Get Directions';
                directions.href = location.url;
                directions.target = '_blank';
                directions.rel = 'noopener noreferrer';
                content.append(name, address, directions);
                infoWindow.setContent(content);
                infoWindow.open({ map, anchor: marker });
            });
        }
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&callback=${callbackName}`;
    script.onerror = restoreStaticMap;
    document.head.append(script);
}
